import { createFileRoute } from '@tanstack/react-router';
import { TenantsList } from '@/screens/RAdmin/Tenants/TenantsList';

export const Route = createFileRoute('/radiant/tenants')({
  component: TenantsList,
});
